<template>
    <ul class="Sidebar__level-2" v-if="items">
        <li v-for="(link, index) in items" :key="index"
            class="Sidebar__level-2__item"
        >
            <router-link :to="link.route">
                <span class="Sidebar__level-2__heading">
                <span class="Sidebar__level-2__title">
                     {{ link.title }}
                </span>
            </span>

            </router-link>
        </li>
    </ul>

    <ul class="Sidebar__level-2"
        v-else-if="sections"
    >
        <li v-for="(section, index) in sections"
            :key="index"
            class="Sidebar__level-2__item"
        >
            <router-link :to="'/site/create/' + section.id">
                <span class="Sidebar__level-2__heading">
                    <span class="Sidebar__level-2__title">
                         {{ section.name }}
                    </span>

                    <span class="Sidebar__level-2__status" :class="{jsComplete:section.complete}">
                        <i class="fas fa-check-circle"
                           v-if="section.complete"
                        ></i>
                        <i class="fas fa-minus-circle"
                           v-else
                        ></i>
                    </span>
                </span>

            </router-link>
        </li>
    </ul>
</template>

<script>

export default {
    props: [
        'items',
        'sections',
        'collapsed'
    ]
};
</script>
